export default __webpack_public_path__ + "static/media/milita-after-workout-top.a8afb928.png";